import { findInputParent } from "./helpers";

export default function() {
  const inputs = document.querySelectorAll(".js-input");
  const forms = document.querySelectorAll(".js-form");

  if (!inputs.length) return;

  function handleValuePresence(_input) {
    const parent = findInputParent(_input);

    if ((_input.value && _input.value.length) || _input.validity.badInput) {
      parent.classList.add("cs-input-container--has-value");
    } else {
      parent.classList.remove("cs-input-container--has-value");
    }
  }

  function onFocusHandler() {
    const parent = findInputParent(this);
    parent.classList.add("cs-input-container--has-value");
  }

  function onBlurHandler() {
    handleValuePresence(this);
  }

  function onChangeHandler() {
    handleValuePresence(this);
  }

  function addEventHandlers(_input) {
    _input.addEventListener("focus", onFocusHandler);
    _input.addEventListener("blur", onBlurHandler);
    _input.addEventListener("change", onChangeHandler);
  }

  function onFormResetHandler() {
    const resetInputs = this.querySelectorAll(".js-input");

    for (let i = 0; i < resetInputs.length; i++) {
      const resetInput = resetInputs[i];
      setTimeout(function() {
        handleValuePresence(resetInput);
      }, 0);
    }
  }

  function onContentLoadedInputHandler() {
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];

      handleValuePresence(input);
      addEventHandlers(input);
    }

    for (let i = 0; i < forms.length; i++) {
      const form = forms[i];

      form.addEventListener("reset", onFormResetHandler, false);
    }

    // Mark values which are initially autocompleted by browser as such that have values.
    const isWebKit = !!window.webkitURL;
    if (!isWebKit) return;

    setTimeout(function() {
      var autofilled = document.querySelectorAll("input:-webkit-autofill");

      for (let i = 0; i < autofilled.length; i++) {
        const parent = findInputParent(autofilled[i]);
        parent.classList.add("cs-input-container--has-value");
      }
    }, 100);
  }

  window.addEventListener("DOMContentLoaded", onContentLoadedInputHandler);
}
